export default "assets/images/icons/map_marker-203d8cf4.svg";